/* 处理套餐列表，更具id显示对应的时长中文等等 */
export function disposeVipList(vipMealList) {
  vipMealList.forEach(item => {
    let vipId = parseInt(item.REAL_ID);

    if (vipId === 1 || vipId === 2) {
      item.DURATION = '1年'
    } else if (vipId === 6 || vipId === 5) {
      item.DURATION = '3个月'
    } else if (vipId === 4 || vipId === 7) {
      item.DURATION = '1个月'
    } else if (vipId === 19 || vipId === 9) {
      item.DURATION = '终身'
    } else if (vipId === 11) {
      item.DURATION = '5年'
    }

    if (Array.isArray(item.LIST) && item.LIST.length) {
      disposeVipList(item.LIST)
    }
  })
  return vipMealList;
}

/* 前端和后端会员id不一致，获取真实的后端会员id */
export function getVipPayId(id, module) {

}
